module.exports = __webpack_public_path__ + "img/tcndxq_img6-6.0ade3c7b.png";